const isNotCam4Domain = document.domain &&
  !document.domain.startsWith('cam4.') &&
  !document.domain.startsWith('www.cam4.');

const routeDefinitions = {
  // eslint-disable-next-line no-script-url
  void: 'javascript: void(0)',
  root: '/',
  broadcaster: '/broadcast',
  beyondthedeck: '/promos/beyondthedeck',
  fanclubs: '/fanclubs',
  oauth2Login: '/oauth2/login',
  studio: '/studio',
  studioProfileConfirmation: '/studio/performer/profile-confirmation/:username',
  studioAddExistingPerformer: '/studio/add-existing-performer',
  studioEarningsReport: '/studio/insights/earnings-report',
  studioEarningsReportDaily: '/studio/insights/earnings-report-daily/:date',
  studioEarningsTopPerformers: '/studio/insights/earnings-top-performers',
  studioDashboard: '/studio/dashboard',
  studioLogin: '/studio/login',
  studioRoster: '/studio/roster',
  studioSettings: '/studio/:user/settings/:view?',
  studioCashout: '/studio/:studioOwnerUsername/settings/cashout',
  studioAdmin: '/studio/admin',
  studioWelcome: '/studio/welcome',
  studioPending: '/studio/pending',
  studioEmail: '/studio/email',
  studioRejected: '/studio/denied',
  studioVerification: '/studio/verification',
  studioInvitation: '/studio/studio-invitation',
  studioPerformerIdentities: '/studio/:performerUsername/identities',
  studioRegistration: '/studio/registration',
  studioOnboardPerformerIdentity: '/studio/:performerName/onboard/id/:identityType/:status',
  studioOnboardPrivacy: '/studio/:performerName/onboard/privacy',
  studioOnboardConfirmation: '/studio/:performerName/onboard/confirmation',
  studioPerformerProfile: '/studio/performer-profile/:performerName',
  studioEditPerformerProfile: '/studio/:user/:performerName/:view?',
  userLogin: '/login',
  performerHubMyAccount: '/:user/settings/performerhub/:view?',
  performerCalendar: '/:user/edit/calendar',
  ageVerification: '/:user/settings/performerhub/age-verification',
  userCashout: '/:user/settings/performerhub/cashout',
  userSettingsProfile: '/:user/settings/profile/:view?',
  userSettingsAccount: '/:user/settings/account/:view?',
  directory: '/:genderPreference',
  privateDirectory: {
    root: '/private',
    filters: '/private/:filter',
    kinks: '/private/:filter/:kink',
  },
  tokenInfo: {
    root: '/token',
    'buying_tokens': '/token/buying_tokens',
    'spending_tokens': '/token/spending_tokens',
    'earning_tokens': '/token/earning_tokens',
  },
  couple: '/couple',
  profile: '/:user',
  profileV2: {
    root: '/:user',
    profile: '/:user/profile',
    fanclub: '/:user/fanclub',
    myShop: '/:user/myshop',
    myShopItem: '/:user/myshop/:videoId',
    gallery: '/:user/gallery',
    gifts: '/:user/gifts',
    wall: '/:user/wall',
    checkout: '/:user/checkout/tokens',
  },
  embedProfileV2: '/:user/embed',
  account: '/:user/edit',
  profileSettings: '/:user/settings',
  tags: '/tags/:genderPreference/:tag',
  tagsMale: '/tags/male',
  tagsFemale: '/tags/female',
  tagsTrans: '/tags/transgender',
  tagsCouples: '/tags/couple',
  tagsAll: '/tags/all',
  tagsGeneral: '/tags',
  twitterCallback: '/twitterCallback',
  achievements: '/:username/achievements',
  allTags: '/tags/:genderPreference',
  help: '/help',
  legal: '/legal',
  library: '/library',
  termsofuse: '/legal/termsofuse',
  termsofuseDmca: '/legal/termsofusedmca',
  privacy: '/legal/privacy',
  cookies: '/legal/cookies',
  ccpa: '/legal/ccpa',
  contact: '/contact',
  statementOfRights: '/legal/statement_of_rights',
  legalContact: '/legal/legal_contact',
  complianceStatement: '/legal/2257_compliance_statement',
  knowYourClient: '/legal/kyc',
  lawEnforcement: '/legal/law_enforcement',
  webcamStudioAgreement: '/legal/webcam-studio-agreement',
  videoUploadRules: '/legal/video-upload-rules',
  contestGeneralRules: '/legal/contest-general-rules',
  performerTraining: '/training ',
  cardStatus: 'https://www.cardstatus.com/',
  mail: '/mail',
  legacyAccountMail: '/:user/edit/email',
  legacyPrivacy: '/:user/edit/privacy',
  accountPrivacy: '/:user/settings/account/privacy',
  security: '/:username/settings/account/security',
  pageNotFound: '/page-not-found',
  faq: '/faq',
  broadcastingInfo: '/broadcasting-info',
  checkout: '/payment/checkout',
  editSecurityQuestions: '/:username/edit/securityQuestions',
  inbox: '/inbox',
  newInbox: '/inbox-new',
  preLander: '/new-cam4bucks',
  copyright: '/2257_compliance_statement',
  gold: '/gold',
  countries: '/countries',
  languages: '/languages',
  errorPage: '/oops',
  appBroadcasting: '/app/broadcasting',
  onboardingNewUser: '/signup/confirm',
  verifyAlternateEmail: '/verifyAlternate',
  verifyMyAge: '/ageVerificationPopup',
  token: '/token',
  contest: {
    root: '/contest',
    month: '/contest/month',
    rules: '/contest/rules',
  },
  checkoutTokens: '/checkout/tokens',
  calendar: '/:user/calendar',
  noProfile: '/error-no-profile',
  smsVerification: '/faq/sms-verification',
  favorites: '/friends_favorites',
  galleries: {
    root: '/:username/settings/profile/galleries',
    new: '/:username/settings/profile/galleries/new',
    gallery: '/:username/settings/profile/galleries/:galleryId',
  },
  profileSettingsRoutes: {
    info: '/:username/settings/profile/info',
    socialMedia: '/:username/settings/profile/social-media',
    html: '/:username/settings/profile/html-bio',
  },
  performerHubShop: '/:username/settings/performerhub/shop',
  performerHubFanClub: '/:username/settings/performerhub/fan-club',
  performerHubAgeVerification: '/:username/settings/performerhub/age-verification',
  popularCams: {
    usa: '/usa-cams',
    germany: '/germany-cams',
    brazil: '/brazil-cams',
    italy: '/italy-cams',
    spain: '/cams/spain',
    uk: '/cams/uk',
    france: '/cams/france',
    english: '/english-webcams',
    german: '/german-webcams',
    spanish: '/cams/spanish',
    portuguese: '/cams/portuguese',
    italian: '/cams/italian',
    french: '/french-webcams',
  },
  directoryAliases: {
    liveSex: '/live-sex',
    liveSexFr: '/sexe-live',
    liveSexIt: '/sesso-live',
    liveSexEs: '/webcam-sexo',
    sexCams: '/sex-cams',
    sexCamsFr: '/cam-sexe',
    sexCamsIt: '/cam-sesso',
    sexChat: '/sex-chat',
    sexChatFr: '/chat-sexe',
    sexChatIt: '/chat-porno',
    sexChatEs: '/chat-sexo',
    freeSex: '/free-sex',
    freeSexFr: '/cam-gratuit',
    freeSexIt: '/chat-gratis',
    freeSexEs: '/chat-gratis',
    freeSexDe: '/sex-gratis',
    freeSexNl: '/gratis-sex',
    camChat: '/cam-chat',
    camChatEs: '/chat-cam',
    camChatDe: '/erotik-cam-chat',
    camChatSv: '/webcam-chat',
    sexVideoChat: '/sex-video-chat',
    sexVideoChatFr: '/sexe-video-chat',
    sexVideoChatIt: '/videochat-sesso',
    sexVideoChatEs: '/video-chat',
    sexVideoChatDe: '/sex-video-chat',
    sexVideoChatNl: '/video-sex-chat',
    sexVideoChatSv: '/webcam-shat',
    pornChat: '/porn-chat',
    pornChatFr: '/chat-porno',
    pornChatIt: '/videochat-porno',
    pornChatEs: '/chat-porno',
    pornChatDe: '/porno-chat',
    pornChatNl: '/live-porno-chat',
    pornChatSv: '/porn-chatt',
    xxxLive: '/xxx-live',
    xxxLiveFr: '/cam-xxx-live',
    xxxLiveIt: '/cam-xxx',
    xxxLiveEs: '/webcam-xxx',
    xxxLiveDe: '/xxx-live',
    adultCams: '/adult-cams',
    adultCamsFr: '/cam-x',
    adultCamsIt: '/cam-adulti',
    adultCamsEs: '/webcam-adultos',
    adultCamsDe: '/erwachsenen-cams',
    adultCamsNl: '/webcam-sex',
    adultCamsSv: '/vuxna-cams',
    nudeCams: '/nude-cams',
    nudeCamsFr: '/cam-nu',
    nudeCamsIt: '/nude-cam',
    nudeCamsEs: '/cam-chicas-desnudas',
    amateurCams: '/amateur-cams',
    amateurCamsFr: '/webcam-amateur',
    amateurCamsIt: '/webcam-amatoriali',
    amateurCamsEs: '/cam-amateur',
    amateurCamsSv: '/amatör-porr',
    fuckCams: '/fuck-cams',
    fuckCamsFr: '/cam-porno',
    fuckCamsIt: '/cam-scopate',
    fuckCamsEs: '/webcam-follada',
    fuckCamsDe: '/fick-cams',
    fuckCamsNl: '/fuck-cams',
    fuckCamsSv: '/knulla-cam',
  },
  emailVerification: '/verify',
  confirmPassword: '/confirmPassword',
  passwordReset: '/password/reminder',
  passwordResetThankYou: '/password/reset/thankyou',
  webrtc: '/webrtcBroadcast',
  twitterTraining: '/training/social-media-cam4/exposing-yourself-on-all-social-media',
  twitterRules: 'https://support.twitter.com/articles/18311-the-twitter-rules',
  twitterConnect: '/twitter-connect',
  admin: {
    entryPage:
    isNotCam4Domain ? '/admin' : '//admin.cam4.com/admin',
    generic: '/studio/admin/:subRoute',
    default: '/studio/admin/pending-performers',
    experimentalTools: '/experimental-tools',
    pendingPerformers: '/studio/admin/pending-performers',
    accessManagement: '/studio/admin/access-management',
    accessManagementDetails: '/studio/admin/access-management-details',
    pendingPerformersAll: '/studio/admin/pending-performers-all',
    needsIdPerformers: '/studio/admin/needs-id-perfomers',
    needsIdStudioPerformers: '/studio/admin/needs-id-studio-perfomers',
    studioOwnerAndAdmins: '/studio/admin/studio-owners-and-admins-complete',
    studioPerformers: '/studio/admin/studio-performers',
    studioPerformersAll: '/studio/admin/studio-performers-all',
    watchList: '/studio/admin/watchlist',
    regularPerformersCashout: '/studio/admin/cashout-regular-performers',
    ownersAndAdminsCashout: '/studio/admin/cashout-owners-and-admins',
    studioPerfomersCashout: '/studio/admin/cashout-studio-performers',
    accountDetails: '/studio/admin/account-details',
    studioManagement: '/studio/admin/studio-management',
    onboarding: '/studio/admin/onboarding',
    spamDetector: '/studio/admin/spam-detector',
    directoryBanner: '/admin/directoryBanners',
    createUser: '/admin/qa-users',
    spamLiveChat: '/admin/spam-live-chat',
    awards: '/admin/awards',
    boostReports: '/admin/boost-reports',
    languageAlgorithm: '/admin/language-algorithm',
    adminLogs: '/admin/logs',
    adminGifts: '/admin/gifts',
    csvMessages: '/admin/csv-messages',
    resetIps: '/admin/reset-ips',
    bannedUsers: '/admin/banned',
    auth: '/admin/auth',
    sponsoredTags: '/admin/sponsored-tags',
    sponsoredTagsEdit: '/admin/sponsored-tags/edit',
    privateShowRatings: '/admin/private-show-ratings',
    bulkBan: '/admin/bulk-ban',
    massGifts: '/admin/mass-gifts',
    imageApproval: '/admin/image-approval',
    adminSEO: '/admin/seoUploadTool',
  },
  paths: {
    none: '',
    cashout: 'cashout',
    earningsHistory: 'earnings-history',
    payoutHistory: 'payout-history',
    ageVerification: 'age-verification',
    manageAdmins: 'manage-admins',
    paymentSettings: 'payment-settings',
    fanclub: 'fan-club',
    shop: 'shop',
    insights: 'insights',
    referral: 'referral',
    blockedCountries: 'blocked-countries',
    dmcaRequest: 'dmca-request',
    transferFunds: 'transfer-funds',
    paymentSubscription: 'payment-subscription',
    studioSecurity: 'security',
  },
  lastCashOut: '/lastcashout',
  jsb: '/disclaimer/jugendschutzbeauftragter',
  bitsafeClosePage: '/bitsafe/success',
  weakPasswordReset: '/weak-password-reset',
  tempted: 'https://tempted.com',
  temptedNakedAndUncut: 'https://tempted.com/naked-and-uncut-hedonism',
};

/**
 * Replace dynamic verbs in the route,
 * eg: routeDefinitions.get(routeDefinitions.studioProfileConfirmation, { username: 'myName' })
 * results ==> /studio/performer/profile-confirmation/myName
 */
const get = (route: string, replacements: {[key: string]: string}): string => {
  let finalRoute = route;
  for (const key in replacements) {
    if (route.includes(key)) {
      const keyRegex = new RegExp(`:${key}\\??`);
      const replacement = replacements[key] && replacements[key].toString().toLowerCase();
      finalRoute = finalRoute.replace(keyRegex, replacement);
    }
  }

  return finalRoute;
};

export const publicRoutes = {};

export const privateRoutes = {
  settings: {
    account: {
      emails: '/:username/settings/account/emails',
      security: '/:username/settings/account/security',
    },
    performerHub: {
      root: '/:username/settings/performerhub',
      fanClub: '/:username/settings/performerhub/fan-club',
      media: '/:username/settings/performerhub/media',
      smartMessages: '/:username/settings/performerhub/smart-messages',
      shop: '/:username/settings/performerhub/shop',
      referral: '/:username/settings/performerhub/referral',
      blockedCountries: '/:username/settings/performerhub/blocked-countries',
      dmcaRequest: '/:username/settings/performerhub/dmca-request',
      cashout: '/:username/settings/performerhub/cashout',
      transferFunds: '/:username/settings/performerhub/transfer-funds',
      payoutHistory: '/:username/settings/performerhub/payout-history',
      insights: '/:username/settings/performerhub/insights',
      earningsHistory: '/:username/settings/performerhub/earnings-history',
      ageVerification: '/:username/settings/performerhub/age-verification',
    },
    profile: {
      info: '/:username/settings/profile/info',
      socialMedia: '/:username/settings/profile/social-media',
      html: '/:username/settings/profile/html-bio',
    },
  },

  studio: {
    settings: {
      root: '/studio/:username/settings',
      security: '/studio/:username/settings/security',
    },
  },
};

export default {
  ...routeDefinitions,
  get,
};
